import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export interface ShinseishaInfo {
  id: number;
  accountId: string;
  email: string;
  kaishaCd: string | null;
  kaishaNm: string;
  groupNm: string;
  kjnNm: string;
  bushoNm: string;
  kengenCd: string;
  kengen: string;
  createdDate: string;
  updatedDate: string;
}

export const Prop2LabelMap = {
  id: "ID",
  accountId: "アカウントID",
  email: "メールアドレス",
  kaishaCd: "会社コード",
  kaishaNm: "会社名",
  groupNm: "グループ名",
  kjnNm: "個人名",
  bushoNm: "部署名",
  kengenCd: "権限コード",
  kengen: "権限",
  createdDate: "登録日時",
  updatedDate: "更新日時",
};
export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "accountId",
    label: Prop2LabelMap.accountId,
    width: ColWidth.md,
  },
  {
    prop: "kaishaNm",
    label: Prop2LabelMap.kaishaNm,
  },
  {
    prop: "groupNm",
    label: Prop2LabelMap.groupNm,
  },
  {
    prop: "kjnNm",
    label: Prop2LabelMap.kjnNm,
  },
  {
    prop: "bushoNm",
    label: Prop2LabelMap.bushoNm,
  },
  {
    prop: "kengen",
    label: Prop2LabelMap.kengen,
    width: ColWidth.sm,
  },
  {
    prop: "createdDate",
    label: Prop2LabelMap.createdDate,
    width: ColWidth.lg,
  },
  {
    prop: "updatedDate",
    label: Prop2LabelMap.updatedDate,
    width: ColWidth.lg,
  },
];
